import _memoize from 'lodash/memoize';
import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { TERTIARY, PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  icon: makeThemeColor(PRIMARY),
  focusedIcon: makeThemeColor(TERTIARY),
};

export const HEIGHT = {
  [HD]: 48,
  [FULL_HD]: 72,
};

export const ICON_SIZE = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const IMAGE_SIZE = {
  [HD]: 40,
  [FULL_HD]: 64,
};

// Padding between icon and label
export const ICON_PADDING = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const getImageSize = screenSize => ({
  w: IMAGE_SIZE[screenSize],
  h: IMAGE_SIZE[screenSize],
});

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    Icon: {
      x: safetyMargins.horizontal[screenSize],
      y: Math.round((HEIGHT[screenSize] - ICON_SIZE[screenSize]) / 2),
      color: colors.icon[colorMode],
    },
    Image: {
      x: safetyMargins.horizontal[screenSize] - Math.round((IMAGE_SIZE[screenSize] - ICON_SIZE[screenSize]) / 2),
      y: Math.round((HEIGHT[screenSize] - IMAGE_SIZE[screenSize]) / 2),
      w: IMAGE_SIZE[screenSize],
      h: IMAGE_SIZE[screenSize],
      shader: {
        radius: IMAGE_SIZE[screenSize] / 2,
      },
    },
  };
};

export const getIconViewBox = _memoize(screenSize => ({
  w: ICON_SIZE[screenSize],
  h: ICON_SIZE[screenSize],
}));
